// extracted by mini-css-extract-plugin
module.exports = {"about-block":"about-profile_about-block__G26hq","bio":"about-profile_bio__oJ9W_","performer-info":"about-profile_performer-info__fARri"};